import React from "react";

import GenericIntegrationCard from "../GenericIntegrationCard";
import { INTEGRATION_KEYS } from "../../../../integrations/IntegrationsHelper";
import steps from "../../../../integrations/onboarding/steps";

export default function HealthIntegrationCard({ controller }) {
  return (
    <GenericIntegrationCard
      controller={controller}
      integrationType={INTEGRATION_KEYS.health}
      integrationStep={steps.health}
      icon={require("../../../../../../assets/integrations/healthBig.png")}
      title="Up to 40% automatic tracking!"
      description="Apple Health tracks your physical activity and sleep for effortless insights."
    />
  );
}
